<script>
export default {
  props: {
    award: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      defaultImage: require('@assets/images/default-award-star-image.png'),
      imageLoadingError: false,
    }
  },
  computed: {
    imageUrl() {
      if (this.imageLoadingError) {
        return this.defaultImage
      }
      return this.award.imageUrl || this.defaultImage
    },
  },
  methods: {
    handleImageError() {
      this.imageLoadingError = true
    },
  },
}
</script>

<template>
  <div :class="$style.awardContainer">
    <RouterLink :to="{ name: 'awards', query: { awardId: award.id } }">
      <img :class="$style.awardPicture" :src="imageUrl" alt="" @error="handleImageError" />
    </RouterLink>
    <div :class="$style.awardInfo">
      <div class="d-flex justify-content-between">
        <h3 class="color-primary-blue font-weight-bold">{{ award.title }}</h3>
        <p class="button-text color-darkest-gray">{{ award.year }}</p>
      </div>
      <p class="p1 color-primary-blue">{{ award.description }}</p>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.awardContainer {
  display: flex;
  padding: 24px;
  margin-right: 5px;
  background: $white;
  border: 0.5px solid $lightest-gray;
  border-radius: 16px;
  box-shadow: 3px 3px 6px rgba(196, 196, 196, 0.3);
}

.awardPicture {
  object-fit: cover;
  width: 72px;
  height: 72px;
  margin-right: 23px;
  cursor: pointer;
  border-radius: 16px;
}

.awardInfo {
  flex-grow: 1;
  min-width: 0;

  h3 {
    margin-bottom: 8px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  p {
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
}
</style>
